<template>
  <selector
    :selected="value"
    :options="trip_types"
    :onChange="(v) => select_trip_type(v)"
    :extra_style="{
      '--button-min-width': '168px',
    }"
    showDividers
    compact
  ></selector>
</template>

<script>
import { TRIP_TYPES, trip_types } from "@liveflight/utilities/origin-destination";
import Selector from "@liveflight/components/blocks/selector.vue";

export default {
  name: "trip-type-selector",
  components: {
    selector: Selector,
  },
  props: {
    value: {
      type: String,
      required: true,
      default: TRIP_TYPES.ROUND_TRIP,
      validator: (value) => Object.values(TRIP_TYPES).includes(value),
    },
    max_origin_destinations: {
      type: Number,
      default: 2, // Default: roundtrip and direct
    },
  },
  computed: {
    trip_types() {
      return trip_types.filter(
        (option) =>
          option.min_origin_destinations <= this.max_origin_destinations,
      );
    },
  },
  mounted() {
    const available_values = this.trip_types.map((t) => t.value);

    if (!available_values.length) {
      return;
    }

    // Sanity check: ensure selected option is in the available list, fallback to first available
    if (!available_values.includes(this.value)) {
      this.select_trip_type(available_values[0]);
    }
  },
  methods: {
    select_trip_type(type) {
      this.$emit("input", type);
    },
  },
};
</script>
